import TcVod from 'vod-js-sdk-v6'
import {getCloudVodSignature} from '@/api/socialSecurity'

let tcVod = null
let uploader = null
let percent = 0

const initTvVod = (mediaFile, percentCallBack, doneCallBack, errCallBack, consultantId) => {
  function getSignature() {
    return getCloudVodSignature(consultantId).then(function(response) {
      console.log('%c [ 社保视频上传签名 ]-12', 'font-size:13px; background:pink; color:#bf2c9f;', response.data)
      return response.data
    })
  }

  getSignature()
  tcVod = new TcVod({
    getSignature: getSignature // 获取上传签名的函数
  })

  uploader = tcVod.upload({
    mediaFile: mediaFile // 媒体文件（视频或音频或图片），类型为 File
  })

  uploader.on('media_progress', function(info) {
    console.log('%c [ 社保视频上传进度 ]-23', 'font-size:13px; background:pink; color:#bf2c9f;', info)
    percent = info.percent
    percentCallBack(percent)
  })

  uploader
    .done()
    .then(function(doneResult) {
      percent = 0
      console.log('%c [ 社保视频上传成功 ]-22', 'font-size:13px; background:pink; color:#bf2c9f;', doneResult)
      doneCallBack(doneResult)
    })
    .catch(function(err) {
      console.log('%c [ 社保视频上传失败 ]-29', 'font-size:13px; background:pink; color:#bf2c9f;', err)
      errCallBack(err)
    })
}

const getPercent = () => {
  return percent
}

export default {
  initTvVod,
  percent,
  getPercent
}
